<template>
    <div class="wrapper" ref="wrapper" :style="{ height: wrapperHeight + 'px' }">
        <ul
            class="live-room"
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="loading"
            infinite-scroll-distance="50"
            v-if="list.length>0"
            ref="viewBox"
        >
            <li class="flex top" v-if="top">
                <div class="left">
                    <div
                        class="avatar"
                        :style="{backgroundImage:`url(${top.userIcon ? top.userIcon: head})`}"
                    ></div>
                    <div class="job">{{top.userType==='host'?'主持人':'嘉宾'}}</div>
                </div>
                <div class="right">
                    <div class="flex-default">
                        <div class="name ellipsis">
                            {{top.userName}}
                            <div class="i">置顶</div>
                        </div>
                        <time>{{ getDate(top.date) | dateCompared}}</time>
                    </div>
                    <!-- 文字 -->
                    <div class="content" v-html="top.content"></div>
                    <!-- 视频  controls-->
                    <div
                        class="video-wrap content video-content"
                        v-if="top && !!top.medias && top.medias.type ==='video'"
                    >
                        <p class="common-video-box">
                            <video
                                class="videoClass common-video live-top-video"
                                :id="top.id"
                                :src="top.medias.url"
                                :poster="top.medias.coverImg"
                                style="object-fit:fill"
                                x-webkit-airplay="allow"
                                controlslist="nodownload"
                                x5-video-player-fullscreen="false"
                                x5-video-orientation="portraint"
                                x5-video-player-type="h5-page"
                                webkit-playsinline
                                controls
                                playsinline
                                preload="auto"
                            ></video>
                        </p>
                    </div>

                    <!-- 音频 -->
                    <div
                        class="content"
                        v-if="!!top && !!top.medias && top.medias.type === 'audio'"
                    >
                        <audio
                            class="audioClass"
                            :src="top.medias.url"
                            controls
                            controlslist="nodownload"
                        ></audio>
                    </div>

                    <!--  img -->
                    <div class="content" v-else-if="!!top.image">
                        <img :src="top.image" alt style="width:60vw;height:35vw" @click="showGallary(top.image)" />
                    </div>

                    <div class="reply" v-for="replie in top.replies" :key="replie.id">
                        <p>
                            <span>回复：</span>
                            <span>{{replie.userName}}</span>
                            {{replie.content}}
                            <img v-if="replie.image" :src="replie.image" alt style="width:60vw;height:35vw" @click="showGallary(replie.image)" />
                        </p>
                    </div>
                </div>
            </li>
            <li class="flex" v-for="item in list" :key="item.id">
                <div class="left">
                    <div
                        class="avatar"
                        :style="{backgroundImage:`url(${item.userIcon ? item.userIcon: head})`}"
                    ></div>
                    <div class="job">{{item.userType==='host'?'主持人':'嘉宾'}}</div>
                </div>
                <div class="right">
                    <div class="flex-default">
                        <div class="name">{{item.userName}}</div>
                        <time>{{getDate(item.date) | dateCompared}}</time>
                    </div>
                    <!-- 文字 -->
                    <div class="content" v-html="item.content"></div>
                    <!--  img -->
                    <div class="content" v-if="!!item.image">
                        <img :src="item.image" style="width:60vw;height:35vw" @click="showGallary(item.image)"/>
                    </div>

                    <!-- 视频 -->
                    <div
                        class="video-wrap content video-content"
                        v-if="!!item && !!item.medias && item.medias.type ==='video'"
                    >
                        <p class="common-video-box">
                            <video
                                class="videoClass common-video"
                                :src="item.medias.url"
                                :poster="item.medias.coverImg"
                                style="object-fit:fill"
                                controlslist="nodownload"
                                x-webkit-airplay="allow"
                                webkit-playsinline="playsinline"
                                x5-video-orientation="portraint"
                                x5-video-player-type="h5-page"
                                x5-video-player-fullscreen="false"
                                webkit-appearance="none"
                                playsinline
                                controls
                                preload="auto"
                            ></video>
                        </p>
                    </div>

                    <!-- 音频 -->
                    <div
                        class="content"
                        v-if="!!item && !!item.medias && item.medias.type === 'audio'"
                    >
                        <audio
                            class="audioClass"
                            :src="item.medias.url"
                            controls
                            controlslist="nodownload"
                        ></audio>
                    </div>

                    <div class="reply" v-for="replie in item.replies" :key="replie.id">
                        <p>
                            <span>回复：</span>
                            <span>{{replie.userName}}</span>
                            {{replie.content}}
                        </p>
                    </div>
                </div>
            </li>
        </ul>
        <div v-else :class="['null-data', 'share-null-data']"></div>
        <p v-if="loading" class="loading">
            <mt-spinner type="fading-circle"></mt-spinner>加载中...
        </p>
        <p v-if="isAll" class="loading">已显示全部内容</p>
    </div>
</template>

<script>
import head from "images/default-head.png";
import api from "src/constants/appapi";
import _ from "lodash";
import { Toast } from "mint-ui";
import { setTimeout } from "timers";
import $ from "jquery";
import { log } from "util";
import { intfc_prefix_common } from 'constants/project'

export default {
    data() {
        return {
            head,
            top: null,
            loading: false,
            isAll: false,
            data: {
                page: {
                    last: 2
                }
            },
            list: [],
            wrapperHeight: 0,
            next: 1,
            time: "",
            clock: null,
            el: null,
            isShowVideo: true,
            isQQBrowse: false,
            isWeixin: false,
            isAndroid: false,
            saveVideo: null
        };
    },

    created() {
        let id = this.$route.params.id;
        this.getLive(id);
        window.appapi = api;
        window.$vm = this;
        this.isSharePage = appapi.isSharePage();
        this.el = setInterval(() => {
            this.getNewLive(this.$route.params.id);
        }, 30000);

        var ua = navigator.userAgent.toLocaleLowerCase();

        if (
            ua.match(/tencenttraveler/) != null ||
            ua.match(/qqbrowse/) != null
        ) {
            this.isQQBrowse = true;
        }
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            this.isWeixin = true;
        }
        let u = navigator.userAgent;
        if (u.indexOf("Android") > -1 || u.indexOf("Adr") > -1) {
            this.isAndroid = true;
        }

    },

    mounted() {
        this.$nextTick(() => {
            this.wrapperHeight =
                document.documentElement.clientHeight -
                this.$refs.wrapper.getBoundingClientRect().top;
        });
    },

    updated() {
        this.audioNewEvent();
        this.videoEvent();
        // this.screenFull();
    },

    destroyed() {
        clearInterval(this.el);
    },

    methods: {
        // screenFull() {
        //     let _this = this;
        //     let videoArray = document.querySelectorAll(".videoClass");
        //     videoArray.length &&
        //         videoArray.forEach(function(i, index) {
        //             // 退出全屏触发的事件
        //             i.addEventListener("x5videoexitfullscreen", function() {
        //                 // const id = $(i).attr("id");
        //                 // _this.setVideoStatus(id, false);
        //                 // alert(document.querySelectorAll('#liveId'))
        //                 // 播放 liveId
        //                 $("#liveId").play();
        //             });
        //         });
        // },
        getLive(articleId) {
            this.loading = true;
            const pageToken = this.next * 1;
            const pageLast = this.data.page.last * 1;
            if (pageToken > pageLast) {
                this.loading = false;
                this.isAll = true;
                return false;
            }
            this.$axios
                .get(
                    `${intfc_prefix_common}/api/v2/live/liveRoomTalk?articleId=${articleId}&pageToken=${pageToken}`
                )
                .then(res => {
                    const result = res;
                    if (res.code === 0) {
                        this.data = result;
                        this.time = result.item.time;
                        this.loading = false;
                        if (result.items && result.items.length > 0) {
                            result.items.map(n => {
                                if (n.top) {
                                    this.top = this.getAvatar(n);
                                    return false;
                                }
                                let newData = this.getAvatar(n);
                                this.list.push(newData);
                            });

                            this.next++;
                        }
                    } else {
                        this.loading = false;
                        Toast(res.msg);
                    }
                });
        },

        getNewLive(articleId) {
            try {
                this.$axios
                    .get(
                        `${intfc_prefix_common}/api/v2/live/newLiveRoomTalk?articleId=${articleId}&time=${this.time}`
                    )
                    .then(res => {
                        const result = res.items;
                        if (res.code === 0) {
                            this.time = res.item.time;
                            let arr = _.remove(result, n => {
                                if (n.top) {
                                    this.top = this.getAvatar(n);
                                    return false;
                                }
                                return true;
                            });
                            let newArr = this.getAvatar(arr);
                            this.list = [...newArr, ...this.list];
                        } else {
                            this.loading = false;
                            Toast(res.msg);
                        }
                    });
            } catch (error) {}
        },

        getDate: date => {
            return date.slice(0, -2) + ":00";
        },

        loadMore() {
            if (this.isAll || this.loading) return false;

            this.getLive(this.$route.params.id);
        },

        audioNewEvent() {
            var audios = document.getElementsByTagName("audio");
            var videos = document.getElementsByTagName("video");
            // 暂停函数
            function pauseAll() {
                var self = this;
                [].forEach.call(audios, function(i) {
                    // 将audios中其他的audio全部暂停
                    i !== self && i.pause();
                });
                [].forEach.call(videos, function(i) {
                    // 将audios中其他的audio全部暂停
                    i !== self && i.pause();
                });
            }

            // 给play事件绑定暂停函数
            [].forEach.call(audios, function(i) {
                i.addEventListener("play", pauseAll.bind(i));
            });
        },
        videoEvent() {
            let videoArray = document.getElementsByClassName("videoClass");
            for (var i = 0; i < videoArray.length; i++) {
                videoArray[i].onpause = function() {};
                videoArray[i].onplay = function() {
                    stop("audioClass");
                    // stopOtherVideo(i);
                };
                function stopOtherVideo(i) {
                    for (var j = 0; j < videoArray.length; j++) {
                        if (!videoArray[j].paused && i !== j) {
                            videoArray[j].pause();
                        }
                    }
                }
                function stop(className) {
                    let tagArray = document.getElementsByClassName(className);
                    for (var i = 0; i < tagArray.length; i++) {
                        if (!tagArray[i].paused) {
                            tagArray[i].pause();
                        }
                    }
                }
            }
        },
        getAvatar(obj) {
            let newObj = Object.assign({}, obj);
            newObj.isShowVideo = false;
            if (obj.userIcon) {
                let userIcon = obj.userIcon;
                let httpStr = userIcon.slice(0, 4);
                if (httpStr !== "http") {
                    newObj.userIcon = this.head;
                }
            }
            return newObj;
        },
        showGallary(src) {
            this.$emit('handleGallary',src)
        }
    }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import "~src/stylus/mixin"

.wrapper {
    overflow: auto;
    -webkit-overflow-scrolling:touch;
}

.live-room {
    margin-top: 48px;
    padding: 0 30px;

    li {
        margin-bottom: 58px;

        .left {
            margin-right: 22px;

            .avatar {
                width: 70px;
                height: 70px;
                background: gray no-repeat 50% / 100%;
                border-radius: 999px;
                background-size: cover;
            }

            .job {
                margin-top: 6px;
                text-align: center;
                font-size: 22px;
                color: #AFAFAF;
            }
        }

        .right {
            flex: 1;
            margin-top: 14px;

            .name {
                font-weight: bold;
                font-size: 28px;
                color: #858585;

                .i {
                    display: inline-block;
                    width: 60px;
                    height: 30px;
                    background: #FB3241;
                    color: #fff;
                    text-align: center;
                    line-height: 32px;
                    font-size: 22px;
                    font-style: normal;
                    font-weight: 200;
                    box-sizing: border-box;
                }
            }

            time {
                margin-left: 10px;
                color: #AFAFAF;
                font-size: 24px;
                width: 240px;
                text-align: right;
            }

            .content {
                margin: 10px 0 4px;
                line-height: 64px;
                font-size: 32px;

                audio {
                    width: 100%;
                }
            }

            .video-content {
                width 600px
                height 360px
                position: relative;

                .common-video-box {
                    width: 100%;
                    height: 100%;

                    .common-video {
                        display: inline-block;
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            .reply {
                color: #9B9B9B;
                font-size: 28px;

                p {
                    line-height: 52px;
                }

                span:nth-of-type(1) {
                    color: #C11531;
                }

                span:nth-of-type(2) {
                    color: #858585;
                    margin-right: 20px;
                }
            }
        }
    }
}

.loading {
    padding-bottom: 50px;
    text-align: center;
    font-size: 24px;
    color: #AFAFAF;
    height: 56px;
    line-height: 56px;
}

.null-data {
    width 560px
    height 560px
    margin: 50px auto 0;
}

.app-null-data {
    background url("~images/null.png") no-repeat 50%/100%
}

.share-null-data {
    background url("~images/null.png") no-repeat 50%/100%
}
</style>


// WEBPACK FOOTER //
// live-room.vue?2830c393